// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"f03dc22b","673":"8908406e","737":"3470eab1","767":"e8e89d17"}[chunkId] + ".chunk.js";
};